var map = {
	"./Bullet-list.svg": "b298",
	"./Camera.svg": "c02d",
	"./Cursor.svg": "8d7c",
	"./Double-check.svg": "fbbf",
	"./Euro.svg": "0cdd",
	"./Layout-top-panel-5.svg": "ae45",
	"./Picture.svg": "3064",
	"./Star.svg": "d29b",
	"./Text.svg": "d697",
	"./Youtube.svg": "b6fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99a8";